import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";
import {} from ".";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CitationItem',
    props: {
        citation: null,
        outputFormat: { default: "bibliography" },
        prefix: { default: "" }
    },
    setup(__props) {
        const props = __props;
        library.add(faExternalLinkAlt);
        const link = computed(() => {
            const citeUrl = props.citation.cite?.data?.[0]?.URL;
            return citeUrl ? decodeURIComponent(citeUrl) : null;
        });
        const citationHtml = computed(() => {
            const citation = props.citation;
            const cite = citation.cite;
            const formattedCitation = cite.format(props.outputFormat, {
                format: "html",
                template: "apa",
                lang: "en-US",
            });
            return formattedCitation;
        });
        return { __sfc: true, props, link, citationHtml, faExternalLinkAlt, FontAwesomeIcon };
    }
});
